"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatOwnersPaged = exports.formatOwners = exports.formatOwnerLabel = void 0;

var _formatName = _interopRequireDefault(require("I18n/utils/formatName"));

var _ReferenceRecord = _interopRequireDefault(require("reference-resolvers/schema/ReferenceRecord"));

var _immutable = require("immutable");

var _indexBy = _interopRequireDefault(require("transmute/indexBy"));

var _get = _interopRequireDefault(require("transmute/get"));

var formatOwnerId = function formatOwnerId(owner) {
  return String(owner.ownerId);
};

var formatOwnerLabel = function formatOwnerLabel(owner) {
  var firstName = owner.firstName;
  var lastName = owner.lastName;
  var fullName = (0, _formatName.default)({
    firstName: firstName,
    lastName: lastName
  });

  if (fullName !== null && fullName.length > 0) {
    return fullName;
  } else {
    return owner.email;
  }
};

exports.formatOwnerLabel = formatOwnerLabel;

var formatOwnerReference = function formatOwnerReference(owner) {
  return new _ReferenceRecord.default({
    id: formatOwnerId(owner),
    label: formatOwnerLabel(owner),
    description: owner.email,
    referencedObject: (0, _immutable.fromJS)(owner)
  });
};

var formatDisabledOwnerReference = function formatDisabledOwnerReference(owner, disabled) {
  return new _ReferenceRecord.default({
    id: formatOwnerId(owner),
    label: formatOwnerLabel(owner),
    description: owner.email,
    referencedObject: (0, _immutable.fromJS)(owner),
    disabled: disabled
  });
};

var formatOwners = function formatOwners(response) {
  return (0, _indexBy.default)((0, _get.default)('id'), (0, _immutable.List)(response).map(formatOwnerReference));
};

exports.formatOwners = formatOwners;

var formatOwnersPaged = function formatOwnersPaged(response, allowList) {
  var results = response.results,
      hasMore = response.hasMore,
      offset = response.offset;
  var formattedResults = allowList ? (0, _immutable.List)(results).map(function (owner) {
    return formatDisabledOwnerReference(owner, !allowList.includes(owner.activeUserId));
  }) : (0, _immutable.List)(results).map(formatOwnerReference);
  return (0, _immutable.Map)({
    hasMore: hasMore,
    offset: offset || 0,
    count: results.length,
    results: formattedResults
  });
};

exports.formatOwnersPaged = formatOwnersPaged;